<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Add Encoding Profile</modal-header>
        </div>
        <div>
          <form-group>
            <field name="Name" :value="name" v-model="name" :error="errors.name" />
          </form-group>
        </div>
        <div>
          <form-group>
            <field name="Slug" :value="slug" v-model="slug" />
          </form-group>
        </div>
        <div>
          <form-group :class="`${errors.data ? 'has-error': ''}`">
            <label class="control-label">FFMPEG Encoding Profile in JSON Format</label>
            <textarea rows="10" class="form-control" v-model="data" placeholder='{
      "module": "@otomo/action-encode",
      "preset": "mp4",
      "output": "encoded.mp4",
      "params": {
            "-acodec": "aac",
            "-ab": "128k",
            "-ar": "44100",
            "-vcodec": "libx264",
            "-r": "25"
        }
}'
            >
            </textarea>
            <span v-if="errors.data" class="help-block">{{ errors.data }}</span>
          </form-group>
        </div>
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'
import {modalMixin} from '@/mixins/modalMixin'
import {encodingProfileMixin} from '@/mixins/encodingProfileMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_add_encoding_profile',
  mixins: [modalMixin, encodingProfileMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Field
  },
  props: {
    show: Boolean
  },
  data: () => ({
    name: '',
    slug: '',
    data: '',
    errors: {
      name: '',
      data: ''
    }
  }),
  methods: {
    confirm () {
      this.errors.name = ''
      this.errors.data = ''
      if (this.name.length <= 0) {
        this.errors.name = 'Name is required'
        return
      } else if (this.data.length <= 0) {
        this.errors.data = 'Valid JSON data is required'
        return
      }
      this.startLoading()
      const data = {
        name: this.name,
        slug: this.slug,
        data: JSON.parse(this.data)
      }
      this.addEncodingProfile(data).then(() => {
        this.addNotification('success', 'Encoding Profile Added.')
        this.getEncodingProfiles().then(() => {
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>

<style lang="scss">
.password-error{
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/encoding-profile/modal-add-encoding-profile.vue